import React from 'react';
import PropTypes from 'prop-types';

const TelDownload = ({ color, width, height, ...other }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 64 64"
    xmlns="http://www.w3.org/2000/svg"
    {...other}
  >
    <path
      d="M20 40c-4.4 0-8-3.6-8-8 0-3.7 2.6-6.8 6.1-7.7C19.6 19.7 24 16 29 16c5.3 0 9.7 4 10.3 9.2C44.6 25.6 48 29.2 48 33.5 48 38 44.4 41 40 41H20z"
      fill={color}
      opacity="0.3"
    />

    <g transform="translate(24, 24) scale(0.5)">
      <path
        d="M20,22.9c-0.1,0-0.2,0-0.3,0c-3.2-0.4-6.4-1.5-9.1-3.2c-2.5-1.6-4.7-3.8-6.3-6.3c-1.8-2.7-2.9-5.9-3.2-9.1
        C1.1,3.5,1.3,2.7,1.8,2.1c0.5-0.6,1.2-1,2-1.1C3.9,1,4,1,4.1,1h3c1.5,0,2.8,1.1,3,2.6c0.1,0.9,0.3,1.8,0.6,2.6
        c0.4,1.1,0.1,2.3-0.7,3.2l-0.7,0.7c1.2,1.8,2.7,3.4,4.6,4.6l0.7-0.7c0.8-0.8,2.1-1.1,3.2-0.7c0.8,0.3,1.7,0.5,2.6,0.6
        c1.5,0.2,2.6,1.5,2.6,3v3c0,0.8-0.3,1.6-0.9,2.1S20.8,22.9,20,22.9z"
        fill={color}
      />
    </g>

    <path
      d="M32 46v6M29 49l3 3 3-3"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

TelDownload.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

TelDownload.defaultProps = {
  color: '#FFFFFF',
  width: 64,
  height: 64,
};

export default TelDownload;



// WEBPACK FOOTER //
// ./src/components/Icons/TelDownload.jsx